import React from 'react';
import { InteractionType } from '@azure/msal-browser';
import {
  MsalAuthenticationResult,
  MsalAuthenticationTemplate,
  MsalProvider
} from '@azure/msal-react';
import GatedApp from 'components/App';
import LwtApp from '@lwtears/lwt-common-frontend/lib/LwtApp';
import { BaseAppProviders } from 'state/providers';
import { getLoginRequest } from './config/auth';
import { hasAuthCookies } from './util/auth-cookie-util';

const USER_CANCELLED_AUTH_CODE = 'AADB2C90091';

const ErrorRedirect: React.FC<MsalAuthenticationResult> = ({ error }) => {
  if (!error || error.errorMessage?.includes(USER_CANCELLED_AUTH_CODE)) {
    window.location.replace('/');
    return null;
  }

  return <div>An error occurred: {error.errorMessage}</div>;
};

const AuthWrapper = ({ useAuth, children }) => {
  if (!useAuth) return children as any;
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={getLoginRequest()}
      errorComponent={ErrorRedirect}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

const LwtApp1 = LwtApp as any;

const App = ({ msalInstance }) => (
  <MsalProvider instance={msalInstance}>
    <BaseAppProviders>
      <LwtApp1>
        <AuthWrapper useAuth={!hasAuthCookies()}>
          <GatedApp />
        </AuthWrapper>
      </LwtApp1>
    </BaseAppProviders>
  </MsalProvider>
);

export default App;
